import type { Locale } from '@faceup/ui-base'
import { DEFAULT_LANGUAGE, type Language } from '@faceup/utils'
import { createContext } from 'react'

export type TextDirection = 'ltr' | 'rtl'

type State = {
  language: Language
  previousLanguage?: Language
  changeLanguage: (language: Language) => void
  changePreviousLanguage: (language: Language) => void
  messages: Record<string, string> | undefined
  basename: string
  antLocale: Locale | undefined
  direction: TextDirection
}

export const LanguageContext = createContext<State>({
  language: DEFAULT_LANGUAGE,
  previousLanguage: undefined,
  changeLanguage: () => undefined,
  changePreviousLanguage: () => undefined,
  messages: undefined,
  basename: '/',
  antLocale: undefined,
  direction: 'ltr',
})
